

export enum EKeywordType {
    TRENDING_PROJECTS = "trending_projects",
}
export interface IKeyword {
  id?: string;
  name: string;
  value: string;
  type?: EKeywordType;
}


export interface ICreateOrUpdateKeyword {
  keywords: IKeyword[];
  seoKeywordDeleteIds: string[];
}